import styled from 'styled-components'
import { sizeMobile } from 'components/globalStyles'
import { TransparentButton } from 'components/common/common_styles'

export const IconContainer = styled.div`
  display: flex;
  gap: 40px;
  visibility: hidden; /* enable if there's ever content for this */

  @media (max-width: ${sizeMobile}) {
    gap: 24px;
  }
`

export const IconGroup = styled(TransparentButton)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  position: relative;
`

export const Underline = styled.img`
  position: absolute;
  bottom: -2px;
`
